<div class="sec-title">
  <h1>Gabarit Bon de Commande</h1>
</div>

<div>
  <a class="btn btn-action" href="/gestion" routerLink="/gestion" role="button">
    <i class="bi bi-arrow-90deg-left"></i> retour à la gestion
  </a>
</div>
<div style="width:100%;">
  <div class="alert alert-success p-3"  role="alert" *ngIf="update_message!=''">{{update_message}}</div>
  <form [formGroup]="editOrdertemplateForm" (ngSubmit)="onSubmit(editOrdertemplateForm.value, orderItemsForm.value)" novalidate>
    <fieldset class="col-12 form-group mb-3">
    <legend>Itèmes dans le Bon de Commande</legend>
    <div class="fieldset-wrap">
      <div class="float-lg-end mb-5 col-sm-12 col-lg-12">
          <div class="float-lg-start mt-3 col-sm-12 col-lg-4">
            <div class="form-group mb-3">
              
            </div>
          </div>
          <div class="float-lg-end mt-3 col-sm-12 col-lg-4">
            <div class="form-group mb-3">
              <label class="form-label-inline">Dernière mise à jour: </label>
              <span>{{order_updated_date | date:'short'}}</span>
            </div>
          </div>
      </div>
      <div class="float-start col-12">
        <div class="float-start col-2">
          <div class="form-group mb-3">
            <label for="last_name" class="form-label">Description	</label>
          </div>
        </div>
        <div class="float-start col-10">
          <div class="float-start form-group mb-3 ms-3 col-2">
            <label  class="form-label">Montant</label>
          </div>
          <div class="float-start form-group mb-3 ms-3 col-1">
            <label class="form-label">Taxable</label>
          </div>
          <div class="float-start form-group mb-3 ms-3 col-1">
            <label class="form-label">Qty comm.</label>
          </div>
          <div class="float-start form-group mb-3 ms-3 col-1">
            <label for="gender" class="form-label">Retirer</label>
          </div>
        </div>
      </div>
      <div class="float-start col-12 ">
        <div  class="form-group mb-3"  *ngFor="let orderItem of orderItemsList; let i = index; trackBy:lineItemID" >
          <div [formGroup]="orderItemsForm" >
          <div class="float-start col-2">
            <div class="form-group mb-3">
              <input type="text" placeholder="itème" class="form-control" name="orderitem_description_{{i}}" id="orderitem_description_{{i}}" formControlName="orderitem_description_{{i}}"  value="{{orderItem.description}}" />
              <input type="hidden" class="form-control" name="orderitem_cadence_{{i}}" id="orderitem_cadence_{{i}}" formControlName="orderitem_cadence_{{i}}" value="{{i}}" />
          
            </div>
          </div>
          <div class="float-start col-10">
            <div class="float-start form-group mb-3 ms-3 col-2">
              <span class="float-start col-10"><input href="javascript:void(0);" type="number" class="form-control amount" (change)="onChangeOrderItemAmount(i, $event.target)" name="orderitem_amount_{{i}}" id="orderitem_amount_{{i}}" formControlName="orderitem_amount_{{i}}"/></span>
              <span class="float-start mt-3 ms-1 col-1">$</span>
            </div>
            <div class="float-start form-group mb-3 ms-3 mt-2 col-1">
              <input type="checkbox" href="javascript:void(0);" (change)="onChangeOrderItemTax(i, $event)" class="float-start form-check-input amount active" name="orderitem_istaxable_{{i}}" id="orderitem_istaxable_{{i}}" formControlName="orderitem_istaxable_{{i}}"  checked  />
              <label for="orderitem_istaxable" class="float-start form-check-label d-inline ms-1">Taxe</label>
            </div>
            <div class="float-start form-group mb-3 ms-3 col-1">
              <input href="javascript:void(0);" type="number" class="form-control amount" (change)="onChangeOrderItemQtyOrder(i, $event.target)" name="orderitem_order-count_{{i}}" id="orderitem_order-count_{{i}}" formControlName="orderitem_order-count_{{i}}"  /> 
            </div>
            <div class="form-group float-start mb-3 ms-3 col-1" *ngIf="i>0">
              <a href="javascript:void(0);" (click)="removeOrderItem(i, $event.target, orderItem.order_item_template_id)" role="button" class="btn-delete" ><i class="bi bi-file-x-fill"></i></a>
            </div>
          </div>
          </div>
        </div>
      </div>
      <div class="float-start col-12">
        <div class="col-2 d-flex float-start">
          <div class="form-group mb-3">
          </div>
        </div>
       
      </div>
      <div class="float-start col-12">
        <div class="col-2 d-flex float-start">
          <div class="form-group mb-3">
          </div>
        </div>
        
      </div>
      <div class="float-start col-12">
        <div class="col-2 d-flex float-start">
          <div class="form-group mb-3">
          </div>
        </div>
        
      </div>
      <div class="float-start col-12">
        <div class="form-group mb-3 ms-3">
          <a href="javascript:void(0);" (click)="addOrderItem()" role="button"><i class="bi bi-plus-circle-fill btn-add-one" ></i><span class="txt-add-one ms-2">Ajouter une description</span></a>
        </div>
      </div>
    </div>
    </fieldset>
    <div class="mb-3 mt-2">
      <span class="sub-label">Date de création :</span> {{order_created_date | date:'medium'}}<br/>
      <span class="sub-label">Dernière mise à jour :</span> {{order_updated_date  | date:'medium'}}  - <span class="sub-label">par : </span>{{created_by_name}}
    </div>
    <button type="submit" class="btn btn-primary">Enregistrer</button>
  </form>
</div>
<hr/>
<div id="print-section"></div>